export const FETCH_RIVALS_START = 'FETCH_RIVALS_START';
export const FETCH_RIVALS_SUCCESS = 'FETCH_RIVALS_SUCCESS';
export const FETCH_RIVALS_FAIL = 'FETCH_RIVALS_FAIL';

export const FETCH_ALL_RIVALS_START = 'FETCH_ALL_RIVALS_START';
export const FETCH_ALL_RIVALS_SUCCESS = 'FETCH_ALL_RIVALS_SUCCESS';
export const FETCH_ALL_RIVALS_FAIL = 'FETCH_ALL_RIVALS_FAIL';

export const FETCH_RIVAL_START = 'FETCH_RIVAL_START';
export const FETCH_RIVAL_SUCCESS = 'FETCH_RIVAL_SUCCESS';
export const FETCH_RIVAL_FAIL = 'FETCH_RIVAL_FAIL';

export const CREATE_RIVAL_START = 'CREATE_RIVAL_START';
export const CREATE_RIVAL_SUCCESS = 'CREATE_RIVAL_SUCCESS';
export const CREATE_RIVAL_FAIL = 'CREATE_RIVAL_FAIL';
export const CREATE_RIVAL_RESET = 'CREATE_RIVAL_RESET';

export const UPDATE_RIVAL_START = 'UPDATE_RIVAL_START';
export const UPDATE_RIVAL_SUCCESS = 'UPDATE_RIVAL_SUCCESS';
export const UPDATE_RIVAL_FAIL = 'UPDATE_RIVAL_FAIL';

export const DELETE_RIVAL_START = 'DELETE_RIVAL_START';
export const DELETE_RIVAL_SUCCESS = 'DELETE_RIVAL_SUCCESS';
export const DELETE_RIVAL_FAIL = 'DELETE_RIVAL_FAIL';

export const REFRESH_RIVAL_LIST = 'REFRESH_RIVAL_LIST';

export const RESET_RIVAL_STORE = 'RESET_RIVAL_STORE';

export const LOGOUT = 'LOGOUT';

export type RivalActionTypes =
  | typeof FETCH_RIVALS_START
  | typeof FETCH_RIVALS_SUCCESS
  | typeof FETCH_RIVALS_FAIL
  | typeof FETCH_ALL_RIVALS_START
  | typeof FETCH_ALL_RIVALS_SUCCESS
  | typeof FETCH_ALL_RIVALS_FAIL
  | typeof FETCH_RIVAL_START
  | typeof FETCH_RIVAL_SUCCESS
  | typeof FETCH_RIVAL_FAIL
  | typeof CREATE_RIVAL_START
  | typeof CREATE_RIVAL_SUCCESS
  | typeof CREATE_RIVAL_FAIL
  | typeof CREATE_RIVAL_RESET
  | typeof UPDATE_RIVAL_START
  | typeof UPDATE_RIVAL_SUCCESS
  | typeof UPDATE_RIVAL_FAIL
  | typeof DELETE_RIVAL_START
  | typeof DELETE_RIVAL_SUCCESS
  | typeof DELETE_RIVAL_FAIL
  | typeof RESET_RIVAL_STORE
  | typeof REFRESH_RIVAL_LIST
  | typeof LOGOUT;
